<template>
    <div>
        <p class="text-grey-900 text-14 pb-1" v-if="label != null">{{ label }}</p>

        <div
            class="input-group h-12 w-full px-3 outline-none flex justify-between items-center"
            :class="[[error ? 'border-error' : 'border-grey-500'], [disabled ? 'disabled' : '']]"
        >
            <div id="cardElement" ref="cardElement" class="w-full h-4" :disabled="disabled" />
        </div>

        <Error v-if="error !== null" :error="stripeErrorMessage" />
    </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        label: { type: String, default: 'Card details' },
        complete: { type: String, default: 'addCard' },
        put: { type: String, default: null },
    },

    data() {
        return {
            script: null,
            stripe: null,
            elements: null,
            card: null,
            error: null,
        }
    },

    created() {
        console.log('created stripe')
        this.setupStripe();

        // useHead({
        //     script: [
        //         {
        //             hid: 'Stripe',
        //             src: 'https://js.stripe.com/v3/',
        //             onLoad: () => this.setupStripe(),
        //         },
        //     ],
        // })
    },

    // mounted() {
    // let script = document.createElement("script");
    // script.src = "https://js.stripe.com/v3/";
    // script.onload = this.setupStripe()

    // this.script = document.body.appendChild(script);
    // },

    beforeDestroy() {
        document.body.removeChild(this.script)
        // console.log('stripe removed from page')
    },

    methods: {
        async setupStripe() {
            this.stripe = await loadStripe('pk_test_TYooMQauvdEDq54NiTphI7jx');
            this.elements = this.stripe.elements()
            this.setupCardElement()


            // setTimeout(() => {
            //     this.stripe = Stripe('pk_test_1UcSFoGSu5lXKzes2JabY9y2')
            //     this.elements = this.stripe.elements()

            //     this.setupCardElement()
            // }, 100)
        },

        setupCardElement() {
            if (this.card != null) return

            this.card = this.elements.create('card', {
                hidePostalCode: true,
                // hideIcon: true,
                style: {
                    base: {
                        fontSize: '14px',
                        color: '#000000',
                        fontFamily: 'Inter, sans-serif',
                        iconColor: '#7C7C7C',
                        fontWeight: 400,
                        '::placeholder': {
                            fontSize: '14px',
                            fontWeight: 400,
                            color: '#7C7C7C',
                        },

                        ':disabled': {
                            color: '#E4E4E4',
                        },
                    },
                    invalid: {
                        iconColor: '#DC583C',
                        color: '#DC583C',
                    },
                },
            })

            this.card.mount('#cardElement')

            this.card.on('change', (event) => {
                if (event.error) {
                    this.error = event.error
                } else {
                    this.error = null
                }
            })
        },

        stripeAttemptPayment(intent, billing_details) {
            console.log('stripeAttemptPayment', intent)
            this.stripe
                .confirmCardSetup(intent, {
                    payment_method: {
                        card: this.card,
                        billing_details: billing_details,
                    },
                })
                .then(
                    function (result) {
                        if (result.error) {
                            this.error = result.error
                            this.$emit('error', result.error)
                            return false
                        }

                        this[this.complete](result.setupIntent.payment_method)
                    }.bind(this),
                )
        },

        addSubscription(payment_method) {
            this.$axios
                .put(this.put, {
                    payment_method: payment_method,
                })
                .then((response) => {
                    this.$emit('complete')
                })
                .catch((error) => {
                    this.error = error
                    this.$emit('error', error)
                })
        },

        addCard(payment_method) {
            this.$axios
                .put('/payment-method', {
                    payment_method: payment_method,
                })
                .then((response) => {
                    this.$emit('complete')
                })
                .catch((error) => {
                    this.error = error
                    this.$emit('error', error)
                })
        },
    },

    computed: {
        stripeErrorMessage() {
            if (this.error == null) return null

            return this.$help
                .capitalizeFirstLetter(
                    this.error.message.replace("Your card's ", '').replace('Your ', '').replace('incomplete', 'required').replace('.', ''),
                )
                .replace('Security code', 'Security code (CVC)')
        },
    },

    watch: {
        disabled() {
            // console.log('saving updated')
            this.card.update({
                disabled: this.disabled,
            })
        },
    },
}
</script>
